export default "__VITE_ASSET__2cc62130__"